import { useState, useEffect } from 'react';
import { getPreReadSignedWriteUrl } from '../../../services/s3Services';

/**
 * Resolves an S3 object key to a signed HTTPS read URL.
 * - If the key is already an https/http/blob URL it is returned as-is.
 * - Returns `null` while the request is in-flight or when key is empty.
 */
export function useS3Url(key: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!key) {
      setUrl(null);
      return;
    }

    /** Already a fully-qualified or blob URL — use directly */
    if (
      key.startsWith('https://') ||
      key.startsWith('http://') ||
      key.startsWith('blob:')
    ) {
      setUrl(key);
      return;
    }

    let cancelled = false;
    getPreReadSignedWriteUrl({ objectKey: key })
      .then((res: any) => {
        if (!cancelled && res?.code === 200 && res?.data) {
          setUrl(res.data as string);
        }
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });

    return () => {
      cancelled = true;
    };
  }, [key]);

  return url;
}
